//scroll down
var scrolldown = document.getElementById("scroll-down");
var featured = document.getElementById("featured");
if(featured) {
  var rect = featured.getBoundingClientRect();
}
if(scrolldown) {
  scrolldown.addEventListener("click", function(){
    window.scroll({
      top: rect.top,
      left: 0,
      behavior: 'smooth'
    })
  })
}
// carruseles home
const swiper = new Swiper('.swiper', {
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
});

// menu
var toogler = document.getElementById("menu-toggle");
var menu = document.getElementById("primary-menu");
var btnClose = document.getElementById("menu-close");
toogler.addEventListener("click", function() {
  var aria = this.getAttribute('aria-expanded');
  if (aria == "true") {
    this.ariaExpanded = "false";
    menu.classList.remove("open");
  } else {
    this.ariaExpanded = "true";
    menu.classList.add("open");
  }
})
btnClose.addEventListener("click", function() {
  toogler.ariaExpanded = "false";
  menu.classList.remove("open");
})

// submenu
var dropdowns = document.querySelectorAll(".menu-item-has-children>a");
for (var i = 0; i < dropdowns.length; i++) {
  dropdowns[i].addEventListener("click", function(e) {
    e.preventDefault();
    var subMenu = this.nextElementSibling;
    if (subMenu.classList.contains('open')) {
      subMenu.classList.remove('open');
    } else {
      subMenu.classList.add('open');
    }
      
  })
}

// Popover share
var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
  return new bootstrap.Popover(popoverTriggerEl, {
    html: true,
    template: '<div class="popover popover--share" role="tooltip"><div class="popover-arrow"></div><div class="popover-body"></div></div>'
  })
})

/*
   BUSCADOR
*/ 

// VARIABLES
var ACTIVE_TAB = 'lista';

var MIN_SEARCH_LENGTH = 3;
var SEARCH_VALUE = false;

var TAGS_FILTERS = [];

var ACTUAL_CATEGORY = (document.getElementById('single_cat_title')) ? document.getElementById('single_cat_title').value : '';

var ACTUAL_TAXONOMY = document.getElementById('taxonomy_search').value;

var FORM_DATA = new FormData();

// SELECCION TAB
var tabPanels = document.querySelectorAll(".tab-panel");
var tabLista = document.getElementById("list");
var tabRed = document.getElementById("network");
[].forEach.call(tabPanels, function(tab) {
  // EVENTO CLICK
  tab.addEventListener("click", function(){
    // QUITO EL ACTIVE 
    [].forEach.call(tabPanels, function(tabElem) {
      tabElem.classList.remove("active");
    });
    // AGREGO EL ACTIVE EN EL CLICK Y SETEO TAB ACTIVO
    tab.classList.add("active");
    ACTIVE_TAB = tab.getAttribute('data-tab');

    if(ACTIVE_TAB == 'lista') {
      tabLista.style.display = 'block';
      tabRed.style.display = 'none';
    } else {
      tabLista.style.display = 'none';
      tabRed.style.display = 'block';
    }

  });
});

// Event Listener INPUT buscar
let timer;              // Timer identifier
const waitTime = 500;   // Wait time in milliseconds

var inputSearch = document.getElementById("search");
inputSearch.addEventListener("input", function(){
    
    clearTimeout(timer);
    // Wait for X ms and then process the request
    timer = setTimeout(() => {
      // MINIMO CARACTERES ?  SETEA FILTRO Y BUSCA
      if(inputSearch.value.length >= MIN_SEARCH_LENGTH){
        SEARCH_VALUE =  inputSearch.value;
        // QUERY
        buildFormData();
      } else {
        SEARCH_VALUE = false;
      }

      // SI O HAY CARACTERES EN EL INPUT BUSCA SIN FILTRAR KEYWORD
      if (inputSearch.value.length == 0){
        // QUERY
        buildFormData();
      }
    }, waitTime );
  
    
});

// Event Listener TAGS
var tagsLabels = document.querySelectorAll(".filter-checkbox");
[].forEach.call(tagsLabels, function(tag) {
  // EVENTO CLICK
  tag.addEventListener("click", function(e){
    // AGREGO O SACO EL ACTIVE EN EL CLICK
    e.stopPropagation();
    e.preventDefault();

    // SACO CUALQUIER OTRO ACTIVE
    [].forEach.call(tagsLabels, function(_tag) {
      if(tag != _tag)
        _tag.classList.remove("active");
    });

    // SACO HIGLIGH POR LAS DUDAS
    if(document.getElementById('post_id') && document.getElementById('is_single')){
      document.getElementById('post_id').remove()
      document.getElementById('is_single').remove()
    }
    
    // AGREGO EL CLICKEADO
    tag.classList.toggle("active");

    // RESET FILTROS
    TAGS_FILTERS = [];
    // GUARDO FILTROS ACTIVOS
    var tagsActiveLabels = document.querySelectorAll(".filter-checkbox.active");
    [].forEach.call(tagsActiveLabels, function(tagActive) {
      // add filtro
      TAGS_FILTERS.push(tagActive.getAttribute('data-slug'));

      // MUESTRO LA INFO DEL TAG
      document.getElementById('tag_name').innerText = tagActive.getAttribute('data-name');
      document.getElementById('tag_desc').innerText = tagActive.getAttribute('data-desc');
    });
    
    // QUERY
    buildFormData();
  });

});

// FUNCION ARMA PARAMETROS
var buildFormData = (category = false) => {
  // RESET FORM DATA
  FORM_DATA = new FormData();
  
  // TAB ACTIVO
  FORM_DATA.append("tab", ACTIVE_TAB);
  
  // INPUT SEARCH
  if(SEARCH_VALUE)
    FORM_DATA.append("search", SEARCH_VALUE);
   
  // TAGS
  if(TAGS_FILTERS.length > 0)
    FORM_DATA.append("tags", TAGS_FILTERS);

  // CATEGORIA
  if(ACTUAL_CATEGORY.length > 0)
    FORM_DATA.append("categoria", ACTUAL_CATEGORY);

  // TAXONOMIA
  if(ACTUAL_CATEGORY.length > 0)
    FORM_DATA.append("taxonomy_search", ACTUAL_TAXONOMY);  
  
  // PARAMS WORDPRESS
  FORM_DATA.append("action", ajax_var.action);
  FORM_DATA.append("nonce", ajax_var.nonce);
  
  // LLAMO AL AJAX
  getData(category);
}

// QUERY AJAX
var getData = (category = false) => {
  const xhttp = new XMLHttpRequest();
  xhttp.responseType = 'json';
  // RESPONSE
  xhttp.onload = function() {
    var jsonResponse = xhttp.response;
    processResponse(jsonResponse, category);
  } 

  xhttp.onreadystatechange = function() {
    if(this.readyState === 4 && this.status === 200) {
      //console.log('OCULTO LOADING');
      document.getElementById('list').classList.remove('loading');
    } else {
      //console.log('MUESTRO LOADING');
      document.getElementById('list').classList.add('loading');
    }
  }
  xhttp.open("POST", ajax_var.url, true);
  xhttp.send(FORM_DATA); 
}


// ARMADO DE TEMPLATE
var processResponse = (resp, category) => {
  var htmlLoop = ''
  // LISTA
  if(resp.lista.length > 0){
    resp.lista.forEach(function (item) {
      
      // SI TIENE PROCESOS LOS RECORRE
      var procesos = '';
      if(item.proceso){
        item.proceso.forEach(function (proccesItem) {
           procesos += `<a href="${proccesItem.link}">${proccesItem.name}</a> - `; // ACA ARMAS LOS <A> si queres que sean links
        });
      }

      // Si hay procesos creo el HTML para el template
      var procesosTpl = '';
      if(procesos.length > 0){
         procesosTpl += `<p class="article-meta article-meta-process">
                            ${procesos}
                        </p>`
      }
      
      
      var styleImg = (item.img) ? `style="background-image:url(${item.img})"` : ``;
      htmlLoop += `<article class="more-article col-md-4">
        <a class="article-image" href="${item.link}" rel="next" ${styleImg}></a>
        <p class="article-meta">
          <a href="#"><span style="background-color:${item.color}"></span>${item.categoria}</a>
        </p>
        ${procesosTpl}
        <h3 class="article-title"><a href="${item.link}" rel="next">${item.titulo}</a></h3>
        <time>${item.fecha}</time>
      </article>`
    });
    document.getElementById('list-container').innerHTML = htmlLoop
  } else {
    document.getElementById('list-container').innerHTML = '<div class="message"><p>The search and/or filters combination has no results.</p></div>'
  }
  


  // RED
  // RESETEO CATEOGRIA
  if(!category){
    document.getElementById('is_process').value = '1';
    document.getElementById('is_category').value = '0';
  } else {
    document.getElementById('is_process').value = '0';
    document.getElementById('is_category').value = '1';
    NG.filterType = 'category';
  }
  

  //console.log(resp)
  document.getElementById('is_process_post_ids').value = resp.red;
  // SETEO POSTS A FILTRAR
  //NG.filterType = 'process';
  //NG.filterValues = resp.red; 
  
  
  //console.log(jQuery('#single_cat_title').val().length);
  jQuery('#graph-refresh-btn').click();


}
